import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';

import { tabLabelWithCount } from '~/components/common/TabCount';
import { pageBandDividerColor } from '~/theme';

/**
 * How many records sit behind each of a detail page's tabs, for the row preview, which
 * shows the header band but not the tabs. Counts wear the tab strip's chip, so they read
 * the same as on the full page. `undefined` while a count is in flight.
 */
export function RelatedCountFields({
  counts,
}: {
  counts: { label: string; value: number | undefined }[];
}) {
  return (
    <>
      <Divider sx={{ my: 2, borderColor: pageBandDividerColor }} />
      <Typography variant="overline" color="text.secondary" display="block" mb={1}>
        Related records
      </Typography>
      <Stack direction="row" flexWrap="wrap" useFlexGap columnGap={3} rowGap={1}>
        {counts.map(({ label, value }) => (
          <Typography key={label} variant="body2" component="div">
            {value === undefined ? (
              <Box
                component="span"
                sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}
              >
                {label}
                <Skeleton variant="rounded" width={22} height={20} animation="wave" />
              </Box>
            ) : (
              tabLabelWithCount(label, value)
            )}
          </Typography>
        ))}
      </Stack>
    </>
  );
}
